import React, {useEffect, useState} from 'react';
import useArticleDetail from '../hooks/useArticleDetail';
import { useRelatedProductsData } from '../hooks/useProductDetailData';
import TakisArticleHero from '../components/TakisArticleHero';
import TakisMediaComponent from '../components/TakisMediaComponent';
import TakisGridSkeleton from "../components/Skeletons/TakisGridSkeleton"
import TakisArticleHeroSkeleton from "../components/Skeletons/TakisArticleHeroSkeleton"
import TakisArticleContentSkeleton from "../components/Skeletons/TakisArticleContentSkeleton"
import TakisSimpleText from '../components/TakisSimpleText';
import TakisAccordion from '../components/TakisAccordion';
import {useStyles} from './Article.styles';
import TakisGrid from "../components/TakisGrid";

const Article = ({pagePath}) => {
  const [articleDetailData, setArticleDetailData] = useState('');
  const { error, isLoading, articleQueryData } = useArticleDetail(pagePath);
  // Related Products
  const [viewRelatedProduct, setViewRelatedProduct] = useState('');
  const { relatedProductsQueryData } =
    useRelatedProductsData(null, viewRelatedProduct);

  const isLoadingHero = isLoading || error || !articleDetailData;

  const classes = useStyles();

  const getComponent = (data, key) => {
    if (data.simpleText) {
      return (
        <TakisSimpleText
          key={key}
          paragraph={data.simpleText.paragraph}
          variation={data.simpleText.variation}
        />
      )
    } else if (data.mediaText) {
      return (
        <TakisMediaComponent
          key={key}
          description={data.mediaText.description}
          imageSrc={data.mediaText.desktopImage.url}
          imageMobileSrc={data.mediaText.mobileImage.url}
          imageAlt={data.mediaText.desktopImage.alt}
          caption={data.mediaText.caption}
          alignImage={data.mediaText.alignImage}
        />
      )
    }
    else if (data.accordion) {
      return (
        <TakisAccordion
          key={key}
          body={data.accordion.accordionBody}
          openCTA={data.accordion.accordionOpenCTA}
          closeCTA={data.accordion.accordionCloseCTA}
          backCTA={data.accordion.accordionBackToTopCTA}
        />
      )
    }
  }

  useEffect(() => {
    if (articleQueryData) {
      setArticleDetailData(articleQueryData);
      setViewRelatedProduct(articleQueryData.viewRelatedProduct);
    }
  }, [articleQueryData]);

  useEffect(() => {
    if (relatedProductsQueryData) {
      setArticleDetailData((prevState) => ({...prevState, ...relatedProductsQueryData}))
    }
  }, [relatedProductsQueryData]);

  if (isLoadingHero) {
    return (
      <>
        <TakisArticleHeroSkeleton/>
        <TakisArticleContentSkeleton/>
        <TakisGridSkeleton/>
      </>
    );
  }

  return (
    <>
      <TakisArticleHero
        imageSrc={articleDetailData.hero.desktopImage.url}
        imageTabletSrc={articleDetailData.hero.tabletImage.url}
        imageMobileSrc={articleDetailData.hero.mobileImage.url}
        imageAlt={articleDetailData.hero.desktopImage.alt}
      />
      <div className={classes.yellowBackground}>
        <div className={classes.yellow} data-aos="zoom-in-left">
          <h1 className={classes.title}>
            {articleDetailData.title}
          </h1>
          {
            articleDetailData.content.map((componentData, index) => (
              getComponent(componentData, index)
            ))
          }
        </div>
      </div>

      {
        (articleDetailData.gridCategory && articleDetailData.gridCategory.items) &&
        <TakisGrid
          title={articleDetailData.viewRelatedProduct.title}
          items={articleDetailData.gridCategory.items}
        />
      }

    </>
  );
};

export default Article;
